import { isArray, isObject, lfirst, oitems, pytruthy } from "./flang";

import { Dropdown } from "../types/general-flank-types";
import { EDropdownGET, ERunGET, ERunNoPayloadGET } from "../types/api-schema";

export function zz(...s: any[]) {
  if (s.length === 0) {
    const fakeError = new Error();
    const stack = fakeError.stack;
    if (stack && stack.split("\n").length >= 3) {
      console.log(stack.split("\n")[2]);
    }
  } else if (s.length === 1) {
    const first = lfirst(s);
    if (isObject(first)) {
      for (const [k, v] of oitems(first)) {
        console.log(k, v);
      }
    } else {
      console.log(first);
    }
  } else if (s.length > 1) {
    console.log(...s);
  }
}

export function fetchFullPathFromInstanceId(
  dropdown: Dropdown | EDropdownGET
): string {
  if (pytruthy(dropdown.kiliId)) {
    const kiliSplit = dropdown.kiliId.split("_");

    return `root.ki_${kiliSplit[0]}.li_${kiliSplit[1]}`;
  } else {
    return `root.li_${dropdown.legoInstanceId}`;
  }
}

export function fetchLegoPathOfRun(run: ERunNoPayloadGET | ERunGET) {
  if (pytruthy(run.kitInstanceId)) {
    return `root.ki_${run.kitInstanceId}.li_${run.legoInstanceId}`;
  }
  return `root.li_${run.legoInstanceId}`;
}

export function fetchFullPathFromKiliId(kiliId: string): string {
  const kiliSplit = kiliId.split("_");
  return `root.ki_${kiliSplit[0]}.li_${kiliSplit[1]}`;
}

export function getLiIdFromLegoPath(legoPath: string) {
  // legoPath is "root.ki_393.li_6359" and it returns 6359 or legoPath is "root.li_7164" and it returns 7164. It returns the integer after "li_"
  const parts = legoPath.split(".");
  const lastPart = parts[parts.length - 1];
  const id = lastPart.split("_")[1];
  return id;
}
// getLiIdFromLegoPath("root.ki_393.li_6359"); //=
// getLiIdFromLegoPath("root.li_7164"); //=

export function getKiIdFromLegoPath(legoPath: string) {
  // legoPath is "root.ki_393.li_6359" and it returns 393. it returns the integer after ki_
  const parts = legoPath.split(".");
  const lastPart = parts[parts.length - 2];
  const id = lastPart.split("_")[1];
  return id;
}

export function getKiliIdOrLiId(legoPath: string) {
  // if legoPath is root.li_7162, it returns 7162 but if legoPath is root.ki_393.li_6359, it returns 393_6359
  const parts = legoPath.split(".");
  const lastPart = parts[parts.length - 1];
  const id = lastPart.split("_")[1];
  if (parts.length === 2) {
    return ["li", id];
  }
  const secondLastPart = parts[parts.length - 2];
  const kiId = secondLastPart.split("_")[1];
  return ["kili", `${kiId}_${id}`];
}

getKiliIdOrLiId("root.ki_393.li_6359"); //=
getKiliIdOrLiId("root.li_7164"); //=

// getKiIdFromLegoPath("root.ki_393.li_6359"); //=

// zz("Hello there!");
// const anObject = { a: 1, b: 2, c: 3 };
// zz({ anObject });
// // zz();

// const recentlySynced = [
//   {
//     credsId: 230,
//     displayName: "hi",
//     state: "completed",
//     response: {
//       syncId: 488,
//       orgId: "test-changelog-1",
//       credsId: 230,
//       initiatedBy: "google-oauth2|104127113553280221549",
//       error: null,
//       additions:
//         '[{"id": "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_bikes_that_should_be_charged_soon", "name": "get_bikes_that_should_be_charged_soon", "is_hidden": false}]',
//       deletions: "[]",
//       updates:
//         '[{"id": 888, "name": "usersOlderThan", "is_hidden": false}, {"id": 1100, "name": "get_user_values_on_startup", "is_hidden": false}, {"id": 1125, "name": "get_past_reservations", "is_hidden": false}, {"id": 918, "name": "game_by_max_score_with_default_2", "is_hidden": false}, {"id": 913, "name": "num_num_num_string", "is_hidden": false}, {"id": 915, "name": "is_even", "is_hidden": false}, {"id": 1098, "name": "get_active_users", "is_hidden": false}, {"id": 1103, "name": "get_on_hold_shipments", "is_hidden": false}, {"id": 889, "name": "second_num_num_num_string", "is_hidden": false}, {"id": 1106, "name": "get_shipments_been_refunded", "is_hidden": false}, {"id": 1139, "name": "get_future_reservations", "is_hidden": false}, {"id": 896, "name": "get_fomf_errors", "is_hidden": false}, {"id": 998, "name": "get_users_by_demo", "is_hidden": false}, {"id": 1032, "name": "usp_OnlyOutputParameters", "is_hidden": false}, {"id": 919, "name": "get_user_by_name", "is_hidden": false}, {"id": 885, "name": "usersNameOnly", "is_hidden": false}, {"id": 897, "name": "getUserAge", "is_hidden": false}, {"id": 906, "name": "get_users_by_name", "is_hidden": false}, {"id": 1099, "name": "get_startup_values", "is_hidden": false}, {"id": 920, "name": "num_num_string", "is_hidden": false}, {"id": 887, "name": "get_user_actions", "is_hidden": false}, {"id": 985, "name": "unban_user", "is_hidden": false}, {"id": 893, "name": "get_user_with_name_age", "is_hidden": false}, {"id": 1124, "name": "get_reservations", "is_hidden": false}, {"id": 904, "name": "num_num_num_string2", "is_hidden": false}, {"id": 916, "name": "updateUser", "is_hidden": false}, {"id": 1101, "name": "get_values_on_startup", "is_hidden": false}, {"id": 1107, "name": "get_refunded_shipments", "is_hidden": false}, {"id": 1104, "name": "get_pending_shipments", "is_hidden": false}, {"id": 886, "name": "get_users", "is_hidden": false}, {"id": 1159, "name": "get_bikes_dont_need_pickup", "is_hidden": false}, {"id": 909, "name": "test_multiset_n", "is_hidden": false}, {"id": 912, "name": "games_with_invalid_dates", "is_hidden": false}, {"id": 907, "name": "type_test_single", "is_hidden": false}, {"id": 891, "name": "delete_user_by_id", "is_hidden": false}, {"id": 1097, "name": "get_lifetime_losers", "is_hidden": false}, {"id": 1123, "name": "get_upcoming_reservations", "is_hidden": false}, {"id": 901, "name": "string_identity_with_default", "is_hidden": false}, {"id": 1034, "name": "PlaceShipmentOnHold", "is_hidden": false}, {"id": 1096, "name": "get_lifetime_winners", "is_hidden": false}, {"id": 895, "name": "get_users_by_year", "is_hidden": false}, {"id": 898, "name": "test_get_huge_card_set_n", "is_hidden": false}, {"id": 1033, "name": "update_email", "is_hidden": false}, {"id": 902, "name": "get_all_restaurants", "is_hidden": false}, {"id": 1030, "name": "get_shipments_by_date", "is_hidden": false}, {"id": 900, "name": "num_num_num_string", "is_hidden": false}, {"id": 890, "name": "type_test", "is_hidden": false}, {"id": 908, "name": "test_get_huge_card_set", "is_hidden": false}, {"id": 1028, "name": "usp_GetUsersWithOutputParameters", "is_hidden": false}, {"id": 1029, "name": "get_shipments", "is_hidden": false}, {"id": 911, "name": "get_user_actions_827", "is_hidden": false}, {"id": 1105, "name": "get_cancelled_shipments", "is_hidden": false}, {"id": 892, "name": "test_throw_dne", "is_hidden": false}, {"id": 903, "name": "get_legal_drinkers", "is_hidden": false}, {"id": 894, "name": "addition_scalar", "is_hidden": false}, {"id": 917, "name": "test_get_one_card", "is_hidden": false}, {"id": 910, "name": "GetOldestUserAge", "is_hidden": false}, {"id": 914, "name": "is_greater", "is_hidden": false}, {"id": 1102, "name": "get_shipments_on_hold", "is_hidden": false}, {"id": 1141, "name": "get_all_bikes", "is_hidden": false}, {"id": 986, "name": "ban_user", "is_hidden": false}, {"id": 1031, "name": "usp_GetUsersAndShipmentsWithOutputParameters", "is_hidden": false}, {"id": 905, "name": "create_user_row", "is_hidden": false}, {"id": 1154, "name": "get_bikes_need_pickup", "is_hidden": false}, {"id": 899, "name": "num_num_num_string3", "is_hidden": false}, {"id": 1160, "name": "get_bikes_low_battery", "is_hidden": false}, {"id": 1161, "name": "get_bikes_good_battery", "is_hidden": false}]',
//       undeletions: "[]",
//     },
//     additions: {
//       "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_bikes_that_should_be_charged_soon": {
//         id:
//           "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_bikes_that_should_be_charged_soon",
//         name: "get_bikes_that_should_be_charged_soon",
//         state: "error",
//         response: {
//           syncLegoId: "488_1162",
//           syncId: 488,
//           legoId: 1162,
//           syncType: "addition",
//           error: null,
//           before: null,
//           after: {
//             name: "get_bikes_that_should_be_charged_soon",
//             paramSchema: "[]",
//             returnSchema: "[]",
//             legoHistoryId: 15289,
//             syncLegoId: "488_1162",
//             legoId: 1162,
//             cloudId:
//               "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_bikes_that_should_be_charged_soon",
//             isDeleted: false,
//             beforeAfter: "after",
//           },
//           kitId: 4701,
//         },
//         syncType: "addition",
//         isHidden: false,
//       },
//     },
//     deletions: {},
//     updates: {},
//     undeletions: {},
//   },
// ];

// const newObj = recentlySynced.map((obj) => {
//   const { additions, ...rest } = obj;
//   return {
//     ...additions,
//   };
// }); //=

// const flattenedData = newObj.map((obj) => {
//   const [key, value] = Object.entries(obj)[0];
//   return { ...value, id: key };
// }); //=

// const newNewObj = flattenedData.map((obj) => {
//   return {
//     kitId: obj.response.kitId,
//     ...obj,
//   };
// }); //=

// const recentlySyncedAdds = [
//   {
//     credsId: 230,
//     displayName: "hi",
//     state: "completed",
//     response: {
//       syncId: 542,
//       orgId: "test-changelog-1",
//       credsId: 230,
//       initiatedBy: "google-oauth2|104127113553280221549",
//       error: null,
//       additions:
//         '[{"id": "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_seven_bikes", "name": "get_seven_bikes", "is_hidden": false}]',
//       deletions: "[]",
//       updates:
//         '[{"id": 888, "name": "usersOlderThan", "is_hidden": false}, {"id": 1100, "name": "get_user_values_on_startup", "is_hidden": false}, {"id": 1125, "name": "get_past_reservations", "is_hidden": false}, {"id": 918, "name": "game_by_max_score_with_default_2", "is_hidden": false}, {"id": 913, "name": "num_num_num_string", "is_hidden": false}, {"id": 915, "name": "is_even", "is_hidden": false}, {"id": 1098, "name": "get_active_users", "is_hidden": false}, {"id": 1103, "name": "get_on_hold_shipments", "is_hidden": false}, {"id": 889, "name": "second_num_num_num_string", "is_hidden": false}, {"id": 1106, "name": "get_shipments_been_refunded", "is_hidden": false}, {"id": 1139, "name": "get_future_reservations", "is_hidden": false}, {"id": 896, "name": "get_fomf_errors", "is_hidden": false}, {"id": 998, "name": "get_users_by_demo", "is_hidden": false}, {"id": 1032, "name": "usp_OnlyOutputParameters", "is_hidden": false}, {"id": 919, "name": "get_user_by_name", "is_hidden": false}, {"id": 885, "name": "usersNameOnly", "is_hidden": false}, {"id": 897, "name": "getUserAge", "is_hidden": false}, {"id": 906, "name": "get_users_by_name", "is_hidden": false}, {"id": 1099, "name": "get_startup_values", "is_hidden": false}, {"id": 920, "name": "num_num_string", "is_hidden": false}, {"id": 887, "name": "get_user_actions", "is_hidden": false}, {"id": 985, "name": "unban_user", "is_hidden": false}, {"id": 893, "name": "get_user_with_name_age", "is_hidden": false}, {"id": 1124, "name": "get_reservations", "is_hidden": false}, {"id": 904, "name": "num_num_num_string2", "is_hidden": false}, {"id": 916, "name": "updateUser", "is_hidden": false}, {"id": 1101, "name": "get_values_on_startup", "is_hidden": false}, {"id": 1107, "name": "get_refunded_shipments", "is_hidden": false}, {"id": 1104, "name": "get_pending_shipments", "is_hidden": false}, {"id": 886, "name": "get_users", "is_hidden": false}, {"id": 1159, "name": "get_bikes_dont_need_pickup", "is_hidden": false}, {"id": 909, "name": "test_multiset_n", "is_hidden": false}, {"id": 912, "name": "games_with_invalid_dates", "is_hidden": false}, {"id": 907, "name": "type_test_single", "is_hidden": false}, {"id": 891, "name": "delete_user_by_id", "is_hidden": false}, {"id": 1097, "name": "get_lifetime_losers", "is_hidden": false}, {"id": 1123, "name": "get_upcoming_reservations", "is_hidden": false}, {"id": 901, "name": "string_identity_with_default", "is_hidden": false}, {"id": 1034, "name": "PlaceShipmentOnHold", "is_hidden": false}, {"id": 1096, "name": "get_lifetime_winners", "is_hidden": false}, {"id": 895, "name": "get_users_by_year", "is_hidden": false}, {"id": 898, "name": "test_get_huge_card_set_n", "is_hidden": false}, {"id": 1033, "name": "update_email", "is_hidden": false}, {"id": 902, "name": "get_all_restaurants", "is_hidden": false}, {"id": 1030, "name": "get_shipments_by_date", "is_hidden": false}, {"id": 900, "name": "num_num_num_string", "is_hidden": false}, {"id": 890, "name": "type_test", "is_hidden": false}, {"id": 908, "name": "test_get_huge_card_set", "is_hidden": false}, {"id": 1028, "name": "usp_GetUsersWithOutputParameters", "is_hidden": false}, {"id": 1029, "name": "get_shipments", "is_hidden": false}, {"id": 911, "name": "get_user_actions_827", "is_hidden": false}, {"id": 1105, "name": "get_cancelled_shipments", "is_hidden": false}, {"id": 892, "name": "test_throw_dne", "is_hidden": false}, {"id": 903, "name": "get_legal_drinkers", "is_hidden": false}, {"id": 894, "name": "addition_scalar", "is_hidden": false}, {"id": 917, "name": "test_get_one_card", "is_hidden": false}, {"id": 910, "name": "GetOldestUserAge", "is_hidden": false}, {"id": 914, "name": "is_greater", "is_hidden": false}, {"id": 1102, "name": "get_shipments_on_hold", "is_hidden": false}, {"id": 1141, "name": "get_all_bikes", "is_hidden": false}, {"id": 986, "name": "ban_user", "is_hidden": false}, {"id": 1031, "name": "usp_GetUsersAndShipmentsWithOutputParameters", "is_hidden": false}, {"id": 905, "name": "create_user_row", "is_hidden": false}, {"id": 1154, "name": "get_bikes_need_pickup", "is_hidden": false}, {"id": 899, "name": "num_num_num_string3", "is_hidden": false}, {"id": 1160, "name": "get_bikes_low_battery", "is_hidden": false}, {"id": 1161, "name": "get_bikes_good_battery", "is_hidden": false}, {"id": 1167, "name": "get_bikes_all", "is_hidden": false}, {"id": 1172, "name": "get_five_bikes", "is_hidden": false}, {"id": 1162, "name": "get_bikes_that_should_be_charged_soon", "is_hidden": false}, {"id": 1164, "name": "get_bikes_near_home", "is_hidden": false}, {"id": 1169, "name": "get_two_bikes", "is_hidden": false}, {"id": 1165, "name": "get_bikes_1440", "is_hidden": false}, {"id": 1170, "name": "get_three_bikes", "is_hidden": false}, {"id": 1173, "name": "get_six_bikes", "is_hidden": false}, {"id": 1166, "name": "get_bikes_not_1440", "is_hidden": false}, {"id": 1168, "name": "get_one_bike", "is_hidden": false}, {"id": 1171, "name": "get_four_bikes", "is_hidden": false}]',
//       undeletions: "[]",
//     },
//     additions: {
//       "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_seven_bikes": {
//         id:
//           "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_seven_bikes",
//         name: "get_seven_bikes",
//         state: "completed",
//         response: {
//           syncLegoId: "542_1174",
//           syncId: 542,
//           legoId: 1174,
//           syncType: "addition",
//           error: null,
//           before: null,
//           after: {
//             name: "get_seven_bikes",
//             paramSchema: "[]",
//             returnSchema: "[]",
//             legoHistoryId: 15587,
//             syncLegoId: "542_1174",
//             legoId: 1174,
//             cloudId:
//               "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_seven_bikes",
//             isDeleted: false,
//             beforeAfter: "after",
//           },
//           kitId: 4713,
//         },
//         syncType: "addition",
//         isHidden: false,
//       },
//     },
//     deletions: {},
//     updates: {},
//     undeletions: {},
//   },
// ];
// const kitIds = recentlySynced.flatMap((obj) => {
//   const { additions } = obj;
//   const responses = Object.values(additions).map(
//     (addition) => addition.response
//   );
//   return responses.map((response) => response.kitId);
// });
// kitIds; //= [4713]
// // recentlySyncedAdds.map((add) => {
// // const { id, name, isHidden, state, response, syncType } = add;
